import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  margin-bottom: 20px;
  flex-direction: row;
  flex-flow: row wrap;
`
export const Center = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`

export const styles = {
  reloadBtnWrapper: {
    display: 'flow-root',
    margin: 10
  },
  reloadtBtn: {
    float: 'right'
  },
  card: {
    width: '100%',
    margin: '10px 5px 0px 5px',
    flexGrow: 1,
    flexShrink: 0,
    flexBasis: '30%'
  },
  icon: {
    fontSize: 48,
    marginRight: 10
  },
  title: {
    marginBottom: 0
  },
  description: {
    color: 'grey'
  }
}



// WEBPACK FOOTER //
// ./src/pages/Dashboard/styles.js